import { Popover, DatePicker } from 'antd'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { ChevronDownIcon } from '@/components/icons/EventsIcons'

interface DateRangeFilterProps {
  selectedRange: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null
  onChange: (dates: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null) => void
  visible: boolean
  onVisibleChange: (visible: boolean) => void
}

export function DateRangeFilter({
  selectedRange,
  onChange,
  visible,
  onVisibleChange,
}: DateRangeFilterProps) {
  const hasSelection = selectedRange && selectedRange[0] && selectedRange[1]

  const content = (
    <div className="w-[280px] p-3">
      <div className="mb-2">
        <span className="text-sm font-medium text-gray-700">Select Date Range</span>
      </div>
      <DatePicker.RangePicker
        value={selectedRange}
        onChange={onChange}
        format="YYYY-MM-DD"
        className="w-full"
        size="small"
        placeholder={['Start Date', 'End Date']}
      />
    </div>
  )

  return (
    <Popover
      content={content}
      trigger="click"
      visible={visible}
      onVisibleChange={onVisibleChange}
      placement="bottom"
      overlayClassName="date-filter-popover"
    >
      <div
        className={classNames(
          'flex items-center justify-between border border-[#d9d9d9] bg-white px-4 h-[32px] text-sm font-normal min-w-[120px] cursor-pointer',
          {
            'text-blue-500 border-blue-500': hasSelection,
          }
        )}
        onClick={() => onVisibleChange(!visible)}
        style={{ lineHeight: '32px' }}
      >
        <div className="flex items-center">
          <span className="font-medium">Date</span>
          {hasSelection && (
            <span className="ml-2 bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs">
              1
            </span>
          )}
        </div>
        <ChevronDownIcon />
      </div>
    </Popover>
  )
}
